import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";
export const TOKEN_KEY = "bhawar_access_token";

export const getToken = () => {
  try { return localStorage.getItem(TOKEN_KEY) || null; } catch { return null; }
};
export const setToken = (t) => {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch { /* ignore */ }
};

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true, // still send cookies when available
});

/**
 * Request interceptor — inject Bearer token.
 *
 * The Preview Pane runs the app in a cross-origin iframe, and modern browsers
 * block third-party HttpOnly cookies there. So we ALSO carry the token in the
 * Authorization header from localStorage. The backend accepts either.
 */
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) {
    cfg.headers = cfg.headers || {};
    if (!cfg.headers.Authorization) cfg.headers.Authorization = `Bearer ${t}`;
  }
  return cfg;
});

/**
 * Response interceptor — global 401 handler.
 *
 * On any non-silent 401, wipe the token and bounce to /login. Return a
 * never-settling promise so the caller's chain does NOT unhandled-reject
 * (avoids React DevServer "Uncaught runtime errors" overlay during redirect).
 */
let bouncing = false;
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      // Always drop the token — it's invalid.
      setToken(null);
      if (!err?.config?.silent401) {
        if (!bouncing && typeof window !== "undefined" && window.location.pathname !== "/login") {
          bouncing = true;
          window.location.replace("/login");
        }
        // swallow — never-settling promise so caller doesn't crash while navigating
        return new Promise(() => {});
      }
    }
    return Promise.reject(err);
  }
);

export const fmtINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n || 0);

export const STATUS_STYLE = {
  draft:     { bg: "bg-slate-100", text: "text-slate-700", border: "border-slate-300", label: "Draft" },
  submitted: { bg: "bg-amber-100", text: "text-amber-800", border: "border-amber-200", label: "Submitted" },
  approved:  { bg: "bg-indigo-100", text: "text-indigo-800", border: "border-indigo-200", label: "Approved" },
  so_raised: { bg: "bg-emerald-100", text: "text-emerald-800", border: "border-emerald-200", label: "SO Raised" },
  fulfilled: { bg: "bg-emerald-200", text: "text-emerald-900", border: "border-emerald-300", label: "Fulfilled" },
  rejected:  { bg: "bg-rose-100", text: "text-rose-800", border: "border-rose-200", label: "Rejected" },
};
